import DOMPurify from 'dompurify';

/** Standards use a mix of inline HTML, Unicode math and Markdown emphasis. */
export function formatStandard(text: string): string {
  const inline = text
    .replace(/&lt;(\/?(?:sup|sub))&gt;/gi, '<$1>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>');
  return DOMPurify.sanitize(inline, { ALLOWED_TAGS: ['sup', 'sub', 'em', 'strong', 'b', 'i', 'br'], ALLOWED_ATTR: [] });
}
